import styled from 'styled-components';
import DataTable from '@components/DataTable';
import { media } from '@simplywallst/ui-core';

export const TableWrapper = styled('div')`
  width: 100%;
  ${media.xsDown`
    width: max-content;
  `}
`;

export const EarningsAndRevenueDataTable = styled(DataTable)`
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  thead tr th {
    ${({ theme }) => theme.typography.tinyStrong};
    height: ${({ theme }) => theme.x4spacePx}px;
    background: ${({ theme }) => theme.color.spaceGray};
  }
  th {
    position: sticky;
    top: 0px;
    z-index: 1;
    padding: ${({ theme }) => theme.x1spacePx}px;
    text-align: left;
  }

  th,
  td {
    &:last-child {
      text-align: left;
    }
  }
  caption {
    text-align: left;
  }
`;
